import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
const ErrorDisplay = ({ isValid, errorText }) => {
    return (_jsx(Fragment, { children: !isValid && (_jsx("p", { className: "text-xs tracking-[.08em] text-red-500", children: errorText })) }));
};
export default ErrorDisplay;
